import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ImmutableEntity, OptionalArrayField } from '@uncinc/react-drupal-core/types';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import { TaxonomyThemes } from '../../../../types/uncinc_profile/taxonomy';

import './style.scss';

interface TaxonomyThemeOverviewTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<TaxonomyThemes>;
  classes: string;
  childThemes: OptionalArrayField<[ImmutableEntity<TaxonomyThemes>]>,
}

const TaxonomyThemeOverviewTeaser: React.FC<TaxonomyThemeOverviewTeaserProps> = ({
  entity, classes, childThemes, ...props
}) => {
  const { t } = useTranslation();
  const theme = entity.toJS();
  const name = theme.name[0].value;
  const url = theme.paths.nl;
  const media = theme.field_media_item;

  const TeaserImg = media.map((teaserItem) => (
    <DynamicMediaItem
      media={teaserItem}
      imageAspectRatio="16_9"
    />
  ));

  return (
    <div className={classNames('ThemeOverviewTeaser', classes)} {...props}>

      <div className="ThemeOverviewTeaser__image">
        <CoreLink href={url}>
          {TeaserImg}
        </CoreLink>
        <div className="triangle triangle--large" />
      </div>
      <div className="ThemeOverviewTeaser__content">
        <div className="ThemeOverviewTeaser__content__title">
          <CoreLink to={url}>
            <h2>{name}</h2>
          </CoreLink>
        </div>

        {childThemes.slice(0, 3).map((childThemeEntity) => {
          const childTheme = childThemeEntity.toJS();
          const childThemeName = childTheme.name[0].value;
          const childThemeUrl = childTheme.paths.nl;
          return (
            <div className="ThemeOverviewTeaser__content__link">
              <span className="icon icon-arrow-right icon-variant-4" />
              <CoreLink to={childThemeUrl} className="ThemeOverviewTeaser__child_link magic-line--after magic-line--after--thick">
                {childThemeName}
              </CoreLink>
            </div>
          );
        })}

        <div className="ThemeOverviewTeaser__content__action">
          <Button href={url} className="Button--secondary">
            {t('organisms.text.full_overview')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TaxonomyThemeOverviewTeaser;
